import {AnyAction, combineReducers} from "redux";
import {configureStore, ThunkAction, ThunkDispatch} from "@reduxjs/toolkit";
import {appReducer} from "./reducers/app-reducer";
import {userReducer} from "./reducers/user-reducer.ts";
import {channelReducer} from "./reducers/channel-reducer.ts";
import {categoriesReducer} from "./reducers/categories-reducer.ts";
import {campaignReducer} from "./reducers/campaign-reducer.ts";
import {transferCampaignReducer} from "./reducers/transferCampaign-reducer.ts";
import {postReducer} from "./reducers/post-reducer.ts";
import {publicationReducer} from "./reducers/singlePublication-reducer.ts";
import {actualPublicationsReducer} from "./reducers/actualPublications-reducer.ts";

export const rootReducer = combineReducers({
    app: appReducer,
    user: userReducer,
    channels: channelReducer,
    categories: categoriesReducer,
    campaigns: campaignReducer,
    transferCampaigns: transferCampaignReducer,
    post: postReducer,
    publications: publicationReducer,
    actualPublications: actualPublicationsReducer,
})
export type AppRootStateType = ReturnType<typeof rootReducer>

export const store = configureStore({
    reducer: rootReducer
})

export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, AppRootStateType, unknown, AnyAction>;

export type AppDispatch = ThunkDispatch<AppRootStateType, unknown, AnyAction>;

// @ts-ignore
window.store = store